import React, { useState, useEffect, useCallback } from "react";

import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import { RoomOutlined, SensorDoorOutlined } from "@mui/icons-material";

import { PageStandard } from "components/admin/PageStandard";
import { BlockStandard } from "components/admin/BlockStandard";
import { useUserContext } from "contexts/UserContext";
import { WifiQuality } from "api/onboardingTypes";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";
import { ReactComponent as Radar } from "components/svgIcons/radar.svg";

/* const STRENGHT_MAP: Record<
  WifiQuality,
  { title: string; description: string; imgSrc: string }
> = {
  offline: {
    title: "Sem sinal",
    description: "Não há cobertura Wi-Fi neste ambiente",
    imgSrc: "",
  },
  bad: {
    title: "Fraca",
    description: "Conexão instável, risco de desconexões",
    imgSrc: "",
  },
  reasonable: {
    title: "Razoável",
    description: "Pode haver pequenas quedas ou lentidão",
    imgSrc: "",
  },
  good: {
    title: "Boa",
    description: "Bom para uso normal, chamadas e automação",
    imgSrc: "",
  },
  great: {
    title: "Excelente",
    description: "Sinal muito forte e estável",
    imgSrc: "",
  },
}; */

/* const mapIntensityToQuality = (dBm: number): WifiQuality => {
  // values range from 0 to -85
  if (dBm >= -85) {
    if (dBm <= -50) {
      return "great";
    } else if (dBm < -65) {
      return "good";
    } else if (dBm < -75) {
      return "reasonable";
    } else {
      return "bad";
    }
  } else return "offline";
}; */

const ONE_MINUTE = 15 * 1000; // 60 sec * 1000 ms

export const WifiQualityAuto = () => {
  const { currentSpace, currentEnvironment } = useUserContext();
  const [strenghtInfo, setStrenghtInfo] = useState<WifiQuality | undefined>();
  const [isDataPending, setIsDataPending] = useState<boolean>(false);
  const setError = useSetError();

  const handleMessage = useCallback((message) => {
    console.log("GOT MESSAGE", message);
  }, []);

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [handleMessage]);

  const handleClick = () => {
    setIsDataPending(true);
    setTimeout(() => {
      setError(CustomCodes.WIFI_MEASUREMENT_FAILED);
      setIsDataPending(false);
    }, ONE_MINUTE);

    // NOT COMPLETE
    // @ts-expect-error
    if (window.ReactNativeWebView) {
      // @ts-expect-error
      window.ReactNativeWebView.postMessage(
        "hiiiiiii from window.ReactNativeWebView"
      );
    }
    // @ts-expect-error
    if (document.ReactNativeWebView) {
      // @ts-expect-error
      window.ReactNativeWebView.postMessage(
        "hiiiiiii from document.ReactNativeWebView"
      );
    }
  };

  const handleRetry = () => {
    setStrenghtInfo(undefined);
    handleClick();
  };

  return (
    <PageStandard title="Medindo qualidade do Wi-Fi">
      <BlockStandard hideDivider>
        <Grid item container alignItems="center">
          <RoomOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentSpace?.schoolName}</Typography>
          <SensorDoorOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentEnvironment?.name}</Typography>
        </Grid>
      </BlockStandard>

      <Grid
        container
        item
        alignItems="center"
        justifyContent="center"
        sx={{ py: 3 }}
      >
        {!strenghtInfo && <Radar />}
      </Grid>

      <BlockStandard hideDivider>
        {!strenghtInfo && (
          <Button
            disabled={isDataPending}
            variant="contained"
            onClick={handleClick}
          >
            {isDataPending ? <CircularProgress /> : "Medir qualidade"}
          </Button>
        )}
        {!!strenghtInfo && (
          <Button
            disabled={isDataPending}
            variant="contained"
            onClick={handleRetry}
          >
            Testar sinal novamente
          </Button>
        )}
      </BlockStandard>
    </PageStandard>
  );
};
